var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 31,
    viewBox: "0 0 41 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3742 0.769531H0.800273C0.358354 0.769531 0 1.12638 0 1.56662V29.4654C0 29.9056 0.358354 30.2625 0.800273 30.2625H39.3742C39.8162 30.2625 40.1745 29.9056 40.1745 29.4654V1.56662C40.1745 1.12638 39.8162 0.769531 39.3742 0.769531ZM1.60055 2.36371H19.2869V7.78407H1.60055V2.36371ZM29.2906 9.37826V14.7588H10.8839V9.37826H29.2906ZM1.60055 9.37826H9.28329V14.7588H1.60055V9.37826ZM1.60055 16.3529H19.2869V21.6936H1.60055V16.3529ZM9.28337 28.6683H1.60055V23.2878H9.28329V28.6683H9.28337ZM29.2906 28.6683H10.8839V23.2878H29.2906V28.6683ZM38.574 28.6683H30.8912V23.2878H38.574V28.6683ZM38.574 21.6936H20.8875V16.3529H38.5739V21.6936H38.574ZM38.574 14.7588H30.8912V9.37826H38.574V14.7588ZM38.574 7.78407H20.8875V2.36371H38.5739V7.78407H38.574Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCement);
export default __webpack_public_path__ + "static/media/cement.aec07a95622f1f92d3061774be8b4a7a.svg";
export { ForwardRef as ReactComponent };